"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _inputGroup = require("./inputGroup.style");
var _FormElements = require("../../styles/FormElements");
var _Label = _interopRequireDefault(require("../Label"));
var _ErrorMessage = _interopRequireDefault(require("../ErrorMessage"));
var _Hint = _interopRequireDefault(require("../Hint"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Input = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      appendGroup,
      className = 'input-group',
      error,
      fit = 'medium',
      hint,
      hintPosition,
      id,
      inputProps,
      label,
      prependGroup,
      value,
      variant = 'default',
      width
    } = props,
    rest = __rest(props, ["appendGroup", "className", "error", "fit", "hint", "hintPosition", "id", "inputProps", "label", "prependGroup", "value", "variant", "width"]);
  return (0, _jsxRuntime.jsxs)(_FormElements.Components.Wrapper, (0, _extends2["default"])({
    width: width,
    className: "wrapper-".concat(className, " ").concat(className)
  }, {
    children: [label && (0, _jsxRuntime.jsx)(_Label["default"], (0, _extends2["default"])({
      className: className,
      label: label,
      fit: fit,
      id: id
    }, rest)), (0, _jsxRuntime.jsxs)(_inputGroup.Components.Wrapper, (0, _extends2["default"])({
      error: error,
      fit: fit,
      variant: variant
    }, {
      children: [prependGroup && (0, _jsxRuntime.jsx)(_inputGroup.Components.PrependGroup, {
        children: prependGroup
      }), (0, _jsxRuntime.jsx)(_inputGroup.Components.InputElement, (0, _extends2["default"])({
        className: className,
        id: id,
        ref: ref,
        variant: variant
      }, inputProps)), appendGroup && (0, _jsxRuntime.jsx)(_inputGroup.Components.AppendGroup, {
        children: appendGroup
      })]
    })), error && (0, _jsxRuntime.jsx)(_ErrorMessage["default"], (0, _extends2["default"])({
      fit: fit
    }, rest)), hint && (0, _jsxRuntime.jsx)(_Hint["default"], (0, _extends2["default"])({
      hint: hint,
      fit: fit
    }, rest))]
  }));
});
var _default = exports["default"] = Input;